import { render, staticRenderFns } from "./FranchisesMainSection.vue?vue&type=template&id=14ec06fa"
import script from "./FranchisesMainSection.vue?vue&type=script&lang=js"
export * from "./FranchisesMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports